import { createRouter } from '@tanstack/react-router';
import { PageSkeleton } from 'components/PageSkeleton';
import { store } from 'store';

// Import from the plugin-generated file at src/routeTree.gen.ts (default TanStack Router output path)
import { routeTree } from '../routeTree.gen';

// Create the TanStack Router instance, threading the Redux store through context
// so route guards (beforeLoad) can read auth state synchronously.
//
// defaultPreload: 'intent' tells TanStack Router to start fetching a route's
// lazy component chunk when the user hovers (or focuses) a Link pointing to it,
// so the chunk is typically already cached by the time they click.
//
// defaultPendingMs / defaultPendingMinMs control how route transitions handle
// slow loads: the previous page stays visible for up to 1200ms while the next
// chunk resolves, and if the pending state does show it stays for at least 600ms
// so the skeleton can't flash. Combined with the LinearProgress in AppBar
// this gives a smooth "old page → progress bar → new page" feel.
//
// defaultViewTransition wraps every navigation in document.startViewTransition,
// so the browser snapshots the outgoing DOM, lets React commit the new route,
// and crossfades them via CSS pseudo-elements (::view-transition-old/new).
// Default browser animation is a ~250ms crossfade — no extra CSS needed.
// Chromium + Safari 18 support it natively; Firefox falls back to an instant
// swap (still works, just no animation).
export const router = createRouter({
  routeTree,
  context: { store },
  defaultPreload: 'intent',
  defaultPendingComponent: PageSkeleton,
  defaultPendingMs: 300,
  defaultPendingMinMs: 300,
  defaultViewTransition: true,
});

// Register the router type globally for type-safe navigation hooks
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
